class OurValues {
  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    if (window.innerWidth <= 920) {
      this.initMobileToggle();
      this.initOutsideClickClose();
    }

    // Re-init on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth <= 920) {
          this.initMobileToggle();
          this.initOutsideClickClose();
        }
      }, 250);
    });
  }

  initMobileToggle() {
    const items = this.container.querySelectorAll('.our-values__item');
    items.forEach((item) => {
      // Remove existing listeners by cloning
      const newItem = item.cloneNode(true);
      item.parentNode.replaceChild(newItem, item);

      newItem.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        newItem.classList.toggle('hover-active');
        const btn = newItem.querySelector('.our-values__toggle-btn');
        if (btn) btn.setAttribute('aria-expanded', newItem.classList.contains('hover-active'));
      });
    });
  }

  initOutsideClickClose() {
    document.addEventListener('click', (e) => {
      const items = this.container.querySelectorAll('.our-values__item');
      items.forEach((item) => {
        if (!item.contains(e.target) && item.classList.contains('hover-active')) {
          item.classList.remove('hover-active');
          const btn = item.querySelector('.our-values__toggle-btn');
          if (btn) {
            btn.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOurValues);
} else {
  initOurValues();
}

function initOurValues() {
  const sections = document.querySelectorAll('.our-values-section');
  sections.forEach((section) => {
    new OurValues(section);
  });
}

// Re-initialize on Shopify section load (theme editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('our-values-section')) {
      new OurValues(event.target);
    }
  });
}
